export function getBgColorById(classId: string) {
  const bgColors = [
    'bg-orange-500',
    'bg-blue-500',
    'bg-green-500',
    'bg-teal-500',
    'bg-purple-500',
  ];

  return classId
    ? bgColors[
        classId.split('').reduce((a, b) => a + b.charCodeAt(0), 0) %
          bgColors.length
      ]
    : bgColors[0];
}

export function getBgGradientById(classId: string) {
  const colors = [
    'bg-gradient-to-r from-red-700 to-[#FF83AE]',
    'bg-gradient-to-r from-orange-500 to-[#FED754]',
    'bg-gradient-to-r from-[#0ABB67] to-[#02A4A4]',
    'bg-gradient-to-r from-blue-700 to-[#02A4A4]',
    'bg-gradient-to-r from-purple-700 to-blue-700',
    'bg-gradient-to-r from-red-600 to-purple-700',
  ];

  return classId
    ? colors[
        classId.split('').reduce((a, b) => a + b.charCodeAt(0), 0) %
          colors.length
      ]
    : colors[0];
}

export function getBorderColorById(classId: string) {
  const colors = [
    'border-t-orange-500',
    'border-t-blue-500',
    'border-t-green-500',
    'border-t-teal-500',
    'border-t-purple-500',
  ];

  return classId
    ? colors[
        classId.split('').reduce((a, b) => a + b.charCodeAt(0), 0) %
          colors.length
      ]
    : colors[0];
}
